import { render, staticRenderFns } from "./NoDataTextComponentGlobal.vue?vue&type=template&id=2de5bde6&scoped=true&"
import script from "./NoDataTextComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./NoDataTextComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./NoDataTextComponentGlobal.vue?vue&type=style&index=0&id=2de5bde6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de5bde6",
  null
  
)

export default component.exports